import type { IconSvgObject } from './types';

const StarsIcon: IconSvgObject = [
  ["path", { d: "M3 12C7.5 12 12 7.5 12 3C12 7.5 16.5 12 21 12C16.5 12 12 16.5 12 21C12 16.5 7.5 12 3 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 5C17.6569 5 19 3.65685 19 2C19 3.65685 20.3431 5 22 5C20.3431 5 19 6.34315 19 8C19 6.34315 17.6569 5 16 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 19.5C3.38071 19.5 4.5 18.3807 4.5 17C4.5 18.3807 5.61929 19.5 7 19.5C5.61929 19.5 4.5 20.6193 4.5 22C4.5 20.6193 3.38071 19.5 2 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default StarsIcon;
